import classNames from 'classnames'
import { cloneElement, forwardRef, isValidElement } from 'react'
import styles from './ListItem.module.scss'
import type { ListItemProps } from './types'

const ListItem = forwardRef<HTMLElement, ListItemProps>((props, ref) => {
  const {
    actionable = false,
    children,
    className,
    focusedFake = false,
    leadingContent: LeadingContent,
    onClick,
    onKeyDown,
    trailingContent: TrailingContent,
    withDivider,
    wrapper,
    ...rest
  } = props

  const listItemClass = classNames(styles['pintxo-list-item'], className, {
    [styles['pintxo-list-item__withDivider']]: !!withDivider,
  })

  const content = (
    <>
      {LeadingContent && (
        <div className={styles['pintxo-list-item__leading-content']}>{LeadingContent}</div>
      )}
      <div className={styles['pintxo-list-item__body-content']}>{children}</div>
      {TrailingContent && (
        <div className={styles['pintxo-list-item__trailing-content']}>{TrailingContent}</div>
      )}
    </>
  )

  if (wrapper && isValidElement(wrapper)) {
    return cloneElement(
      wrapper,
      {
        ...wrapper.props,
        ...rest,
        className: classNames(wrapper.props.className, listItemClass),
        'data-actionable': actionable,
        'data-focused-fake': focusedFake,
        onClick,
        onKeyDown,
        ref,
      },
      content
    )
  }

  return (
    <div
      className={listItemClass}
      data-actionable={actionable}
      data-focused-fake={focusedFake}
      onClick={onClick}
      onKeyDown={onKeyDown}
      ref={ref as React.RefObject<HTMLDivElement>}
      {...rest}
    >
      {content}
    </div>
  )
})

ListItem.displayName = 'ListItem'
export default ListItem
